













import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { IIsolatedHistory } from '../models/russia';
import { ApexOptions } from 'apexcharts';
import { undoChartImage, cumulativeHistory, byDateHistory } from '../helpers/chart-helpers';
import { IHistory } from '../models/world';

@Component({})
export default class IsolatedChart extends Vue {

	public chartCumulative = false;
	public get series() {
		return [{
			data: this.yesGraph,
			name: 'Да',
		},
		{
			data: this.noGraph,
			name: 'Нет',
		}];
	}
	public options: ApexOptions = {
		chart: {
			type: 'line',
			toolbar: {
				tools: {
					download: false,
					reset: undoChartImage,
					pan: false,
				},
			},
			zoom: {
				autoScaleYaxis: true,
			},
		},
		stroke: {
			curve: 'smooth',
		},
		colors: ['#1565c0', '#c62828'],
		title: {
			text: 'Динамика соблюдения режима изоляции',
			align: 'left',
			style: {
				fontWeight: 'normal',
				fontSize: '20px',
			},
		},
		dataLabels: {
			enabled: false,
			offsetY: -4,
			background: {
				opacity: 0.7,
				dropShadow: {
				},
			},
			formatter: (val: number) => {
				return val.toLocaleString();
			},
		},
		tooltip: {
			enabled: true,
		},
		xaxis: {
			labels: {
				formatter: (val, opts) => {
					if (val) {
						return this!.$options!.filters!.formatDateMonth(val!);
					}
					return val;
				},
			},
		},
		yaxis: {
			labels: {
				formatter: (val, opts) => {
					if (val) {
						return (parseInt(val + '', 10).toLocaleString() as any);
					}
					return val;
				},
			},
			forceNiceScale: true,
		},
	};

	public get yesGraph(): IHistory[] | undefined {
		const data = this.$store.getters['russia/getIsolated'] as IIsolatedHistory[];
		const yesOnly = data.map((v) => ({ x: v.x, y: v.yes }));
		if (this.chartCumulative) {
			return cumulativeHistory(yesOnly);
		} else {
			return byDateHistory(yesOnly);
		}
	}

	public get noGraph(): IHistory[] | undefined {
		const data = this.$store.getters['russia/getIsolated'] as IIsolatedHistory[];
		const noOnly = data.map((v) => ({ x: v.x, y: v.no }));
		if (this.chartCumulative) {
			return cumulativeHistory(noOnly);
		} else {
			return byDateHistory(noOnly);
		}
	}

	public mounted() {
		this.$nextTick(() => {
			if ((this.$refs.isolatedChart as any)) {
				setTimeout(() => {
					(this.$refs.isolatedChart as any).updateSeries(this.series);
				}, 300);

			}
		});
	}
}
